module.exports = __webpack_public_path__ + "assets/img/7K.d7b6eb00.png";